export function getApiUrl(path = ""): string {
  let url = import.meta.env.VITE_API_URL;
  if (!url) {
    url = window.location.origin.replace("-v3", "");
  }
  return `${path}`;
}
